import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EdpData } from '../../../catalog/products/interface/context';
import { SchemeBase } from '../../checkout/cart/scheme.class';
import { ContextServiceBase } from '../context.service';
import { ProductContextSerializedInterfaceBase } from './product-context-serialized.interface';

export class ProductContextBase {
    public keySerialize: string = 'ProductContext';
    public scheme: SchemeBase;
    public planType: string;

    public static unserialize(
        data: ProductContextSerializedInterfaceBase,
        contextService: ContextServiceBase,
    ): Observable<ProductContextBase> {
        return contextService
            .unserialize(data.contextService)
            .pipe(map((res) => new ProductContextBase(res, data.plan, data.edp)));
    }

    constructor(
        public contextService: ContextServiceBase,
        public plan?: string,
        public edp: boolean = false,
        public edpData?: EdpData,
    ) {}

    public create(
        plan: string = this.plan,
        edp: boolean = this.edp,
        edpData: EdpData = this.edpData,
    ): ProductContextBase {
        return new ProductContextBase(this.contextService, plan, edp, edpData);
    }

    public serialize(): ProductContextSerializedInterfaceBase {
        return {
            plan: this.plan,
            edp: this.edp,
            planType: this.planType,
            contextService: this.contextService.serialize(),
        };
    }
}
